import { useEffect, useState } from "react";

// Match the history grid's sm (2 columns) and xl (4 columns) breakpoints.
// Each page is capped at three rows, including on narrow screens.
export function useConceptBoardHistoryPageSize() {
  const readSize = () => typeof window === "undefined" ? 12
    : window.matchMedia("(min-width: 1280px)").matches ? 12
    : window.matchMedia("(min-width: 640px)").matches ? 6 : 3;
  const [pageSize, setPageSize] = useState(readSize);

  useEffect(() => {
    const tablet = window.matchMedia("(min-width: 640px)");
    const desktop = window.matchMedia("(min-width: 1280px)");
    const update = () => setPageSize(desktop.matches ? 12 : tablet.matches ? 6 : 3);
    update();
    tablet.addEventListener("change", update);
    desktop.addEventListener("change", update);
    return () => {
      tablet.removeEventListener("change", update);
      desktop.removeEventListener("change", update);
    };
  }, []);

  return pageSize;
}
